export enum FORMULAIRE_EMIT_EVENT {
    REFRESH = 'REFRESH',
    REDIRECT = 'REDIRECT',
    UPDATE_FOLDER = 'UPDATE_FOLDER'
}

export enum FORMULAIRE_FORM_ELEMENT_EMIT_EVENT {
    DUPLICATE_ELEMENT = 'DUPLICATE_ELEMENT',
    DELETE_ELEMENT = 'DELETE_ELEMENT',
    UNDO_CHANGES = 'UNDO_CHANGES',
    VALIDATE_SECTION = 'VALIDATE_SECTION',
    CREATE_QUESTION = 'CREATE_QUESTION',
    REFRESH_QUESTION = 'REFRESH_QUESTION',
    MOVE_QUESTION = 'MOVE_QUESTION',
    CHANGE_FILE_PICKER = 'CHANGE_FILE_PICKER'
}

export enum FORMULAIRE_BROADCAST_EVENT {
    DISPLAY_FILES = 'DISPLAY_FILES',
    INIT_FORM_EDITOR = 'INIT_FORM_EDITOR',
    INIT_FORM_PROP = 'INIT_FORM_PROP',
    INIT_FORM_RESULTS = 'INIT_FORM_RESULTS',
    INIT_RECAP_QUESTIONS = 'INIT_RECAP_QUESTIONS',
    INIT_RESPOND_QUESTION = 'INIT_RESPOND_QUESTION',
    INIT_RGPD_QUESTION = 'INIT_RGPD_QUESTION'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/formulaire-event.ts